import React, { useEffect, useState } from "react";
import { Button, Card, Form, notification, Skeleton, Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useStoreUpdaterWithAPI } from "../../../../Hooks/UseStoreUpdaterWithApi";
import {  EmissionFactorGrid, ManualEntryGrid, UserConfigGrid } from "../../../../Common/UIConstants";
import { useSelector } from "react-redux";
import {  CONFIGURATION_EMISSION_FACTOR } from "../../../../Common/Constants";
import UserPopup from "../../../CommonScreens/CreateManualEntry";
import ManualEntryPopup from "../../../CommonScreens/CreateManualEntry";
import { APIConstants } from "../../../../Common/APIConstants";
import EmissionFactorPopup from "../../../CommonScreens/CreateEmissionFactor";
// import UserPopup from "../../../CommonScreens/CreateUser";

const EmissionFactor = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { loading, makeRequest } = useStoreUpdaterWithAPI();
    const [selectedSiteID, setSelectedSiteID] = useState(null);
    const[refetch, setRefetch] =useState(false);
    const [rowData, setRowData] = useState([])
      const [isUpdate, setIsUpdate] = useState(false);
     const [selectedRow, setSelectedRow] = useState(null);
    const [isAdd, setIsAdd] = useState(false);
   
    const mode = useSelector((state) => state.darkMode);
  
    const { isdarkMode } = mode;
  
    const [form] = Form.useForm();
    const color = useSelector((state) => state.ThemeChange);
    console.log(color)
  
    useEffect(() => {
    
    }, []);
  
    // useEffect(() => {
    //   if (location.pathname === `${CONFIGURATION_EMISSION_FACTOR}/new-user-add-popup`) {
    //     setIsAdd(true);
       
    //   }else {
    //     setIsAdd(false);
      
    //   }
    // }, [location.pathname]);
  
   
  
    const handleNotification = (msg) => {
      notification.open({
        message: `${msg}`,
      });
    };
  
    const handleAddPopup = () => {
      navigate(`${CONFIGURATION_EMISSION_FACTOR}/emission-factor-add-popup`);
    };
  
  
    const handleDeleteSubmit = (groupID) => {
      console.log(groupID)
      try {
        makeRequest({
          type: APIConstants.DELETE,
          url: `${APIConstants.DELETE_ENERGY_SOURCE_MANUAL_ENTRY}?autoId=${groupID?.autoID}`,
        });
  
        const updatedFlowGroupList = flowGroupList.filter(
          (item) => item.groupID !== groupID
        );
        setFlowGroupList(updatedFlowGroupList);
  
        handleNotification("Successfully Deleted");
        form.resetFields();
      } catch (err) {
        console.log(err);
      }
    };

      const getResponse = () => {
        // setIsLoading(true);
        console.log('first')
        makeRequest({ 
          type: APIConstants.GET, 
          url: `${APIConstants.GET_EMISSION_FACTOR_MANUAL_ENTRY}`,
        }).then((res) => {
          // setIsLoading(false);
          console.log(res)
          if (Array.isArray(res)) {
            const updatedData = res.map((item) => ({
              ...item,
              actions: {
                // update: handleUpdatePopup,
                confirmDelete: handleDeleteSubmit,
              },
            }));
            setRowData(updatedData);
            // onClose();
          } else {
            console.error('Expected array but got:', res);
          }
        }).catch((err) => {
          // setIsLoading(false);
          console.error('API request failed', err);
        });
      };
        const handleUpdatePopup = (rowData) => {
          console.log("Selected Row Data:", rowData);
          setIsAdd(false)
          setIsUpdate(true)
          setSelectedRow(rowData)  // Log the row data
          navigate(`${CONFIGURATION_EMISSION_FACTOR}/emission-factor-add-popup`);
        
        };
    
      useEffect(() => {
        getResponse();
      }, [selectedSiteID,refetch]);
        
        useEffect(() => {
          console.log("Selected Row in Modal:", selectedRow); 
          if (isAdd && !selectedRow) {
            form.resetFields(); 
          } else if (isUpdate && selectedRow) {
            form.setFieldsValue(selectedRow); 
          }
        }, [isAdd, isUpdate, selectedRow, form]);
      console.log(rowData)
      console.log(isAdd)
      
   
    return (
      <div>
        <Card className={`w-full h-auto dark ${isdarkMode ? 'darkmode border-0' : 'whitemode'} `}>
          <div className="flex justify-end">
            <Button onClick={handleAddPopup}  
            className="flex justify-center items-center secondary-btn mb-2"
          style={{ "--secondary-color": color.themeConfig.secondaryColor,"--primary-color": color.themeConfig.colorPrimary }}>
              Add Entry
            </Button>
          </div>
  
          <EmissionFactorPopup
             isAdd={isAdd}
             setIsAdd={setIsAdd}
             isUpdate={isUpdate}
             setIsUpdate={setIsUpdate}
             setRefetch={setRefetch}
             refetch={refetch}
             title={selectedRow ? "Edit Manual  Entry" : "Add New Manual  Entry"}
             selectedRow={selectedRow}
          />
          
          <div className="overflow-auto">
            <Spin indicator={<Spin size="large" />} spinning={loading}>
              <EmissionFactorGrid
              data={rowData}
                handleDeleteSubmit={handleDeleteSubmit}
              />
            </Spin>
          </div>
        </Card>
      </div>
    );
};

export default EmissionFactor;
